"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentsTotal = exports.getTotalFuelCharge = exports.getCreditsTotal = exports.getOtherChargesTotal = exports.getBillingPeriodProgress = exports.migratedBalanceCorrection = exports.deepClone = void 0;
var date_1 = require("./date");
function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.deepClone = deepClone;
function migratedBalanceCorrection(_a, transactions) {
    var pounds = _a.pounds;
    var startBalance = transactions
        .filter(function (_a) {
        var description = _a.description;
        return description === 'Migrated Balance';
    })
        .reduce(function (total, _a) {
        var migratedBalance = _a.netCredit.pounds;
        return Number(migratedBalance) + total;
    }, Number(pounds));
    return { pounds: startBalance.toString() };
}
exports.migratedBalanceCorrection = migratedBalanceCorrection;
var getBillingPeriodProgress = function (start, end) {
    if (!start || !end) {
        return {
            progress: 1,
            total: 1,
            daysRemaining: 0,
        };
    }
    var progress = (0, date_1.daysInRange)(start, Date.now());
    var total = (0, date_1.daysInRange)(start, end);
    var daysRemaining = total - progress; // checking undefined as 0 is valid number
    return { progress: progress, total: total, daysRemaining: daysRemaining };
};
exports.getBillingPeriodProgress = getBillingPeriodProgress;
var getOtherChargesTotal = function (period) {
    return period.upgrades.reduce(function (runningTotal, transaction) {
        return Number(transaction.grossCharge.pounds) > 0
            ? runningTotal +
                Number(transaction.grossCharge.pounds) *
                    (1 - (transaction.taxRate || 0) / 100)
            : runningTotal;
    }, 0) +
        period.transactions.reduce(function (runningTotal, transaction) {
            return Number(transaction.netCredit.pounds) < 0
                ? runningTotal + Math.abs(Number(transaction.netCredit.pounds))
                : runningTotal;
        }, 0);
};
exports.getOtherChargesTotal = getOtherChargesTotal;
var getCreditsTotal = function (period) {
    return period.transactions.reduce(function (runningTotal, transaction) {
        return Number(transaction.netCredit.pounds) > 0
            ? runningTotal + Number(transaction.netCredit.pounds)
            : runningTotal;
    }, 0);
};
exports.getCreditsTotal = getCreditsTotal;
var getTotalFuelCharge = function (fuel) {
    return Number((fuel === null || fuel === void 0 ? void 0 : fuel.consumption.netCharge.pounds) || 0) +
        Number((fuel === null || fuel === void 0 ? void 0 : fuel.standing.netCharge.pounds) || 0);
};
exports.getTotalFuelCharge = getTotalFuelCharge;
// gets total payments including negative values e.g. refunds
var getPaymentsTotal = function (payments) {
    return payments.reduce(function (acc, payment) { return acc + Number(payment.credit.pounds); }, 0);
};
exports.getPaymentsTotal = getPaymentsTotal;
